export default {
  title: 'Votre mot de passe a été modifié.',
  information: 'Vous pouvez utiliser votre nouveau mot de passe pour vous connecter dès maintenant',
};
